import { ServicesAuthWrapper } from './ServicesAuthWrapper/ServicesAuthWrapper';
import { ApiService } from './api/ApiService';
import { Customers } from './loyalty/Customers';
import { SstServices } from './sst/SstServices';

export const SstServiceWithAuth = ServicesAuthWrapper(SstServices);
export const LoyaltyServiceWithAuth = ServicesAuthWrapper(Customers);

type SecurityDataType = { token: string };

export const BASE_API_PATH = {
  SST: '/purina-api/sst',
  LOYALTY: '/purina-api/loyalty/v1',
  API: `${
    process.env.GATSBY_SITE_URL && process.env.GATSBY_SITE_URL !== 'http://localhost:3001/'
      ? process.env.GATSBY_SITE_URL
      : 'https://dev-h20.purina.com/'
  }api/sst`,
};

export const api = new ApiService({ baseUrl: BASE_API_PATH.API });

export const AuthSstService = new SstServiceWithAuth({
  baseUrl: BASE_API_PATH.SST,
  baseApiParams: {
    secure: true,
    credentials: 'omit',
  },
  securityWorker: (securityData: SecurityDataType | null) => {
    if (securityData) {
      return {
        headers: {
          Authorization: securityData.token,
        },
      };
    }
    return {};
  },
});

// Doesn't need to be wrapped in ServicesAuthWrapper because refreshToken is handled by @nestle-npus-nbm/pup-script
// https://github.com/nestle-npus-nbm/esp-purina-auth/blob/main/src/auth-auth0-client.ts#L331
export const Auth0SstService = new SstServices({
  baseUrl: BASE_API_PATH.SST,
  baseApiParams: {
    secure: true,
    credentials: 'omit',
  },
  securityWorker: (securityData: SecurityDataType | null) => {
    if (securityData) {
      return {
        headers: {
          Authorization: securityData.token,
        },
      };
    }
    return {};
  },
});

export const AuthLoyaltyService = new LoyaltyServiceWithAuth({
  baseUrl: BASE_API_PATH.LOYALTY,
  baseApiParams: {
    secure: true,
    credentials: 'omit',
  },
  securityWorker: (securityData: SecurityDataType | null) => {
    if (securityData) {
      return {
        headers: {
          Authorization: securityData.token,
        },
      };
    }
    return {};
  },
});

export const Auth0LoyaltyService = new Customers({
  baseUrl: BASE_API_PATH.LOYALTY,
  baseApiParams: {
    secure: true,
    credentials: 'omit',
  },
  securityWorker: (securityData: SecurityDataType | null) => {
    if (securityData) {
      return {
        headers: {
          Authorization: securityData.token,
        },
      };
    }
    return {};
  },
});
